app.controller('PresentationController', ['$scope', '$rootScope', '$interval', '$window', '$document', '$timeout',
    function($rootScope, $scope, $interval, $window, $document, $timeout) {
    $scope.presentation = $window.$presentation;
    $scope.boards = $scope.presentation.boards;
    $scope.display_id = 0;
    $scope.updated = 0;

        (function worker() {
            if(window.location.href.includes("pid")){
                console.log("running it");
                $.ajax({
                    type: "GET",
                    url: "/presentationmanager/getRefreshValue/"+$scope.presentation.id,
                    async: true,
                    success: function(data) {
                        if($scope.updated == 1){
                            $scope.updated =0
                            $.ajax({type: "GET", url: "/presentationmanager/refreshImagesOff/"+$scope.presentation.id, async: false});
                            var xhr = new XMLHttpRequest();
                            var uriOfCachedPage = window.location.href;
                            xhr.open("GET", uriOfCachedPage, true);
                            xhr.setRequestHeader("Cache-Control", "max-age=0");
                            xhr.send();
                            $.ajax({
                                type: "GET",
                                url: "/presentationmanager/getGlobalRefresh",
                                async: true,
                                success: function(data) {
                                    if(data != true){
                                        $window.location.reload(true);
                                    }
                                }});
                        }
                        if(data==1){
                            $scope.updated =1;
                        }
                    },
                    complete: function() {
                        setTimeout(worker, 10000);
                    }
                });
            }

        })();



    (function() {
        // Make sure we're listening for keypresses
        $document.bind("keydown", function(event) {
            $timeout(function() {
                keyPressed(event);
            })
        });

        // Set the refresh interval to only 1 minute if there are no boards assigned.

            var refreshInterval = ($scope.boards.length > 0) ? ($scope.presentation.refresh_interval * 1000 * 60) : (60000);

        // Refresh every requested interval, if the browser is online
        if(refreshInterval > 0) {
            $interval(function() {
                if ($rootScope.online) {
                    $.ajax({
                        type: "GET",
                        url: "/presentationmanager/getGlobalRefresh",
                        async: true,
                        success: function(data) {
                            if(data != true){
                                refresh();
                            }

                        }});
                }
            }, refreshInterval);
        }
    })();

    // Display the next board in the pres.


    var nextBoard = function() {
        $scope.display_id = ($scope.display_id + 1) % $scope.boards.length;
    }


    // Display the prev board in the pres.
    var prevBoard = function() {
        $scope.display_id = (($scope.display_id - 1) < 0) ? ($scope.boards.length - 1) : ($scope.display_id - 1);
    }

    var refresh = function() {
        var xhr = new XMLHttpRequest();
        var uriOfCachedPage = window.location.href;
        xhr.open("GET", uriOfCachedPage, true);
        xhr.setRequestHeader("Cache-Control", "max-age=0");
        xhr.send();
        window.location.reload(true);
    }

    var keyPressed = function(e) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if(charCode == 32 || charCode == 39) {
            nextBoard();
        } else if(charCode == 37) {
            prevBoard();
        } else if(charCode == 82) {
            refresh();
        }
        window.isPaused = false;
    };

    $scope.$on('board-finished', function() {
        nextBoard();
        window.isPaused = false;
    });
}]);